import crossbarCenterDayImg from '@assets/web-v3-images/crossbar-day-center.png';
import crossbarLeftDayImg from '@assets/web-v3-images/crossbar-day-left.png';
import crossbarRightDayImg from '@assets/web-v3-images/crossbar-day-right.png';
import giftActiveImg from '@assets/web-v3-images/gift-active.png';
import giftImg from '@assets/web-v3-images/gift.png';
import coinImg from '@assets/web-v3-images/icons/crown-coin-icon.png';
import lineCrossbarImg from '@assets/web-v3-images/line-crossbar.png';
import subGiftActiveImg from '@assets/web-v3-images/sub-gift-active.png';
import subGiftImg from '@assets/web-v3-images/sub-gift.png';
import { Text } from '@radix-ui/themes';
import { Tooltip } from 'radix-ui';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LbImg from "@assets/web-v3-images/coin.png";
import coinsImg from "@assets/web-v3-images/icons/shwe-hour-coin.png";
import puzzleImg from "@assets/web-v3-images/icons/puzzlex5.png";
import HeartImg from "@assets/web-v3-images/icons/Heart.png";
import TicketImg from "@assets/web-v3-images/icons/turnto.png";
import reviewItemsImg from "@assets/web-v3-images/image.png";

function useWindowSize() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const resize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  return width;
}

export default function ProgressDay({ data }) {
  const { t, i18n } = useTranslation()
  const [openDay, setOpenDay] = useState(null);

  const days = (data?.track ?? [])?.map((item) => ({
    ...item,
    active: item.state === 'CLAIMED' || (item.cycle_day === data.cycle_day && data.today_claimed), // check true đến ngày bao nhiêu sẽ thêm trường active
  }));
  const widthScreen = useWindowSize();

  const BAR_HEIGHT = widthScreen < 640 ? 20 : widthScreen < 1024 ? 35 : 35;

  const activeDays = days?.filter((item) => item.active);

  // Tìm ngày hiện tại (state === "TODAY")
  const todayItem = days?.find((item) => item.state === "TODAY");

  // Nếu có ngày TODAY thì progress chạy tới đó,
  // nếu không tìm thấy (edge case) thì fallback về ngày claimed cuối cùng
  const lastClaimedDay = todayItem
    ? todayItem.cycle_day
    : activeDays.length > 0
      ? activeDays[activeDays.length - 1].cycle_day
      : 0;

  // cycle_day không phải lúc nào cũng bắt đầu từ 1 (vd chu kỳ chạy 16 -> 30),
  // nên phải quy về vị trí (index) của item trong mảng days đang hiển thị
  // thay vì dùng thẳng giá trị cycle_day để tính % chiều rộng.
  const lastClaimedIndex = days.findIndex((item) => item.cycle_day === lastClaimedDay);
  const lastClaimedPosition = lastClaimedIndex >= 0 ? lastClaimedIndex + 1 : 0;

  const progressWidth = `${((lastClaimedPosition - 0.5) / days.length) * 100}%`;

  const scrollRef = useRef(null);
  const activeRef = useRef(null);

  // Vị trí cần cuộn tới là ngày TODAY (hoặc fallback ngày claimed cuối, dùng chung
  // logic với lastClaimedDay) chứ không phải ngày "active" cuối cùng — nếu hôm nay
  // chưa claim thì item TODAY không có active=true nên sẽ bị bỏ qua, khiến cuộn sai vị trí
  const currentDay = lastClaimedDay;

  useEffect(() => {
    // dùng scrollTo thủ công thay vì scrollIntoView vì scrollIntoView có thể
    // cuộn nhầm ancestor (vd modal cha) thay vì scrollRef, khiến hộp quà
    // hiện tại (thường ở cuối danh sách) bị show sai ở vị trí đầu
    const rafId = requestAnimationFrame(() => {
      const container = scrollRef.current;
      const el = activeRef.current;
      if (!container || !el) return;

      const targetScrollLeft =
        el.offsetLeft - container.clientWidth / 2 + el.clientWidth / 2;

      container.scrollTo({
        left: targetScrollLeft,
        behavior: "smooth",
      });
    });

    return () => cancelAnimationFrame(rafId);
  }, [currentDay, days.length]);


  const REWARD_ICON_MAP = {
    COIN: coinsImg,
    TURN: puzzleImg,
    LP: LbImg,
    MAGIC_WHEEL_HEART: HeartImg,
    MATHMATCH_TICKET: TicketImg,
    REVIVE_ITEM: reviewItemsImg
  };

  const DEFAULT_REWARD_ICON = coinsImg;

  function getRewardIcon(rewardType) {
    return REWARD_ICON_MAP[rewardType] ?? DEFAULT_REWARD_ICON;
  }

  // Đóng tooltip khi chạm ra ngoài (cho mobile)
  useEffect(() => {
    const handleOutsideClick = () => setOpenDay(null);
    document.addEventListener('touchstart', handleOutsideClick);
    return () => document.removeEventListener('touchstart', handleOutsideClick);
  }, []);

  return (
    <div className="">
      <div
        ref={scrollRef}
        className="
							overflow-x-scroll
							overflow-y-hidden
							pb-2 sm:pb-4
							scrollbar-thin
							scrollbar-thumb-[#E6B97D]
							scrollbar-track-transparent"
      >
        <div className="relative w-full min-w-max">
          {/* Background */}
          <div
            className="absolute top-9 sm:top-17 md:top-17 lg:top-17 xl:top-17 left-0 flex items-center w-full h-30"
            style={{ height: BAR_HEIGHT }}
          >
            <img src={crossbarLeftDayImg} style={{ height: BAR_HEIGHT }} />

            <div
              className="flex-1"
              style={{
                height: BAR_HEIGHT,
                backgroundImage: `url(${crossbarCenterDayImg})`,
                backgroundRepeat: 'repeat-x',
                backgroundSize: 'auto 100%',
              }}
            />

            <img src={crossbarRightDayImg} style={{ height: BAR_HEIGHT }} />
            {/* Progress */}
            <div
              className="absolute left-2 top-[6px] sm:top-[8px] h-[8px] sm:h-[16px] overflow-hidden rounded-l-full rounded-r-full"
              style={{ width: progressWidth }}
            >
              <img src={lineCrossbarImg} className="h-full w-full" />
            </div>
          </div>

          {/* Days */}
          <div className="grid grid-cols-[repeat(15,50px)] sm:grid-cols-[repeat(15,103px)] gap-x-1 sm:gap-x-2 w-max">
            {days?.length > 0 &&
              days?.map((item) => {
                const isReward = item.is_milestone || item.id % 5 === 0; // check cột mốc quan trọng 5, 10, 15
                const icon = isReward
                  ? item.active
                    ? giftActiveImg
                    : giftImg
                  : item.active
                    ? subGiftActiveImg
                    : subGiftImg;

                const rewardType = item?.rewards?.[0]?.reward_type;
                const rewardIcon = getRewardIcon(rewardType);

                return (
                  <Tooltip.Provider delayDuration={0}>
                    <Tooltip.Root
                      key={item.cycle_day}
                      open={openDay === item.cycle_day}
                      onOpenChange={(isOpen) => setOpenDay(isOpen ? item.cycle_day : null)}
                    >
                      <Tooltip.Trigger asChild>
                        <div
                          ref={item.cycle_day === currentDay ? activeRef : null}
                          className="w-full flex flex-col items-center z-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenDay((prev) => (prev === item.cycle_day ? null : item.cycle_day));
                          }}
                        >
                          <div className="h-20 sm:h-35 md:h-35 lg:h-35 xl:h-35 flex items-center justify-center">
                            <img
                              src={icon}
                              className={`
                                  ${item.state === 'TODAY'
                                  ? `${isReward ? 'h-13 sm:h-24' : 'w-11 sm:w-22'} animate-today-pulse filter-[drop-shadow(0_0_5px_rgba(240,176,39,0.9))_drop-shadow(0_0_5px_rgba(240,176,39,0.7))] scale-120`
                                  : item.active
                                    ? `${isReward ? 'h-16 sm:h-29' : 'w-13 sm:w-26'} mb-1.5 sm:mb-2.5`
                                    : `${isReward ? 'h-13 sm:h-24' : 'w-11 sm:w-22'}`
                                }
                                `}
                            />
                          </div>

                          <p
                            className={` text-center font-bold text-[#7b5125] mb-3 ${i18n.language === 'en' ? 'text-xs sm:text-[23px]' : 'text-[14px] sm:text-[25.5px]'} ${!item.active && item.state !== 'SKIPPED' && item.state !== 'TODAY' ? 'opacity-60' : ''}`}
                          >
                            {t("shwe_journey.day")} {item.cycle_day}
                          </p>
                        </div>
                      </Tooltip.Trigger>
                      <Tooltip.Portal>
                        <Tooltip.Content className="TooltipContent" sideOffset={-9}>
                          <div className="relative inline-flex">
                            <div
                              className="
															bg-[rgba(254,251,232,1)]
															shadow-[0_8px_12px_-2px_rgba(10,13,18,0.12),0_16px_24px_-4px_rgba(10,13,18,0.08)]
															py-1.5 sm:py-2.5
															px-2 sm:px-4
															rounded-2xl
															flex
															items-center
															justify-center
															gap-2
														"
                            >
                              <img src={rewardIcon} alt="coin" className="h-4 sm:h-7" />
                              <Text className="text-[rgba(113,59,18,1)] font-semibold text-[11px] sm:text-[14px]">
                                x{item?.rewards?.[0]?.reward_amount}  {item?.rewards?.[0]?.reward_name}
                              </Text>
                            </div>
                          </div>
                          {/* Mũi tên xuống */}
                          <Tooltip.Arrow
                            width={16}
                            height={8}
                            style={{ fill: 'rgba(254,251,232,1)', marginTop: "-1px" }}
                          />
                        </Tooltip.Content>
                      </Tooltip.Portal>
                    </Tooltip.Root>
                  </Tooltip.Provider>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
